import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR, NgModel} from '@angular/forms';
import {ValueAccessorBase} from '../../class/value-accessor';

@Component({
  selector: 'app-switch',
  template: `
    <label class="switch" style="margin-bottom: 0">
      <input type="checkbox" [(ngModel)]="value"/>
      <span class="switch-track {{type}}"></span>
      <span class="switch-thumb" [attr.data-label-on]="labelOn" [attr.data-label-off]="labelOff"></span>
    </label>
  `,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SwitchComponent,
    multi: true,
  }]
})
export class SwitchComponent extends ValueAccessorBase<boolean> implements OnInit {

  @Input() labelOn: string;
  @Input() labelOff: string;
  @Input() type: string;

  @ViewChild(NgModel) model: NgModel;


  ngOnInit() {
    this.labelOn = this.labelOn || 'YES';
    this.labelOff = this.labelOff || 'NO';
    this.type = this.type || 'switch-success';
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/forms/components/switch/switch.component.ts